import React, { useEffect } from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import SessionBanner from "./SessionBanner";
import { Outlet } from "react-router-dom";
import { useSidebar } from "../context/SidebarContext";
import { NotificationProvider } from "../context/NotificationContext";

export default function MainLayout() {
  const {
    isCollapsed,
    isHovered,
    toggleSidebar,
    expandFully,
    onHover,
    onLeave,
    isMobile,
    isMobileSidebarOpen,
    closeMobileSidebar,
  } = useSidebar();

  const isSidebarOpen = !isCollapsed || isHovered;

  useEffect(() => {
    window.dispatchEvent(new Event("resize"));
  }, []);

  useEffect(() => {
    window.dispatchEvent(new Event("resize"));
  }, [isCollapsed, isHovered]);

  const mainClasses = [
    "main-content",
    isMobile ? "full-width" : (!isSidebarOpen ? "sidebar-collapsed" : ""),
  ].filter(Boolean).join(" ");

  return (
    <NotificationProvider>
    <div className="app-shell">
      <Sidebar
        isCollapsed={isCollapsed}
        isHovered={isHovered}
        toggleSidebar={toggleSidebar}
        expandFully={expandFully}
        onHover={onHover}
        onLeave={onLeave}
        isMobile={isMobile}
        isMobileOpen={isMobileSidebarOpen}
        closeMobileSidebar={closeMobileSidebar}
      />
      <div className={mainClasses}>
        <Header toggleSidebar={toggleSidebar} />
        <SessionBanner />
        <div className="page-content overflow-y-auto flex-1">
          <Outlet />
        </div>
      </div>
    </div>
    </NotificationProvider>
  );
}
